// extracted by mini-css-extract-plugin
export default {"searchResults":"kqF8Uedn","header":"cGL9ji43","contents":"myQHb_p7"};